// site_content.email_settings (plan step 17): the switches and timings for
// abandoned-cart reminders and the delivery follow-up. The
// send-scheduled-emails function reads the same row
// (supabase/functions/_shared/scheduled-core.ts readSettings, same limits).

export var DEFAULT_EMAIL_SETTINGS = {
  abandoned_enabled: true,
  abandoned_1_hours: 1,
  abandoned_2_hours: 24,
  abandoned_promo_code: null,
  followup_enabled: true,
  followup_days: 5
};

export var LIMITS = { h1Min: 1, h1Max: 72, h2Max: 168, followupMin: 1, followupMax: 60 };

function whole(v, fallback) {
  var n = typeof v === 'number' ? v : (typeof v === 'string' && v.trim() ? Number(v) : NaN);
  return Number.isFinite(n) ? Math.round(n) : fallback;
}

// What's saved, on top of the defaults (for the form).
export function readEmailSettings(saved) {
  var s = saved && typeof saved === 'object' && !Array.isArray(saved) ? saved : {};
  var d = DEFAULT_EMAIL_SETTINGS;
  return {
    abandoned_enabled: typeof s.abandoned_enabled === 'boolean' ? s.abandoned_enabled : d.abandoned_enabled,
    abandoned_1_hours: whole(s.abandoned_1_hours, d.abandoned_1_hours),
    abandoned_2_hours: whole(s.abandoned_2_hours, d.abandoned_2_hours),
    abandoned_promo_code: typeof s.abandoned_promo_code === 'string' && s.abandoned_promo_code.trim() ? s.abandoned_promo_code.trim().toUpperCase() : null,
    followup_enabled: typeof s.followup_enabled === 'boolean' ? s.followup_enabled : d.followup_enabled,
    followup_days: whole(s.followup_days, d.followup_days)
  };
}

function isWhole(v) {
  return typeof v === 'number' ? Number.isInteger(v) : /^\s*\d+\s*$/.test(String(v));
}

// form (numbers may be strings from the inputs) -> { settings, error }
export function validateEmailSettings(form) {
  var h1 = Number(form.abandoned_1_hours);
  var h2 = Number(form.abandoned_2_hours);
  var days = Number(form.followup_days);
  if (!isWhole(form.abandoned_1_hours) || h1 < LIMITS.h1Min || h1 > LIMITS.h1Max) {
    return { settings: null, error: 'The first reminder must be sent after 1 to 72 hours (whole hours).' };
  }
  if (!isWhole(form.abandoned_2_hours) || h2 <= h1 || h2 > LIMITS.h2Max) {
    return { settings: null, error: 'The second reminder must come later than the first, and within 168 hours (7 days).' };
  }
  if (!isWhole(form.followup_days) || days < LIMITS.followupMin || days > LIMITS.followupMax) {
    return { settings: null, error: 'The follow-up must be sent 1 to 60 days after delivery (whole days).' };
  }
  var code = typeof form.abandoned_promo_code === 'string' ? form.abandoned_promo_code.trim().toUpperCase() : '';
  return {
    settings: {
      abandoned_enabled: form.abandoned_enabled === true,
      abandoned_1_hours: h1,
      abandoned_2_hours: h2,
      abandoned_promo_code: code || null,
      followup_enabled: form.followup_enabled === true,
      followup_days: days
    },
    error: null
  };
}
